import PropTypes from 'prop-types'
import { InputProptypes, wrap } from 'components/form/InputWrapper'
import preventDefault from 'prevent-default'
import classNames from 'classnames'
import { noop } from 'lodash'
import { forwardRef } from 'react'

const SearchInput = forwardRef(
  (
    {
      id,
      name,
      value,
      defaultValue,
      onFocus,
      onBlur,
      onChange = noop,
      onValueChange = noop,
      onError,
      maxLength,
      onSearch,
      disabled = false,
      error = false,
      type = 'text',
    },
    ref
  ) => {
    const handleChange = event => {
      onChange(event)
      onValueChange(event.target.value)
    }
    return (
      <form onSubmit={preventDefault(onSearch)} autoComplete="off">
        <input
          type={type}
          className={classNames('inp_txt', {
            in_active: disabled,
            in_error: error,
          })}
          id={id}
          name={name}
          value={value}
          defaultValue={defaultValue}
          ref={ref}
          onFocus={onFocus}
          onBlur={onBlur}
          onChange={handleChange}
          maxLength={maxLength}
          disabled={disabled}
          autoComplete="off"
        />
        <button type="submit" className="btn_search">
          <span className="ico_comm ico_search">검색</span>
        </button>
      </form>
    )
  }
)

SearchInput.propTypes = {
  ...InputProptypes,
  type: PropTypes.oneOf(['text', 'search']),
  disabled: PropTypes.bool,
  error: PropTypes.any,
  onValueChange: PropTypes.func,
  onSearch: PropTypes.func,
}
SearchInput.displayName = 'SearchInput'

export default wrap(SearchInput, { className: 'box_inptxt search_inp2' })
